game.resources = [
  {
    "name": "16x16_font",
    "src": "assets/game/16x16_font.png",
    "type": "image"
  },
  {
    "name": "32x32_font",
    "src": "assets/game/32x32_font.png",
    "type": "image"
  },
  {
    "name": "DC_small",
    "src": "assets/game/DC_small.png",
    "type": "image"
  },
  {
    "name": "cuadro",
    "src": "assets/game/cuadro.png",
    "type": "image"
  },
  {
    "name": "fondo",
    "src": "assets/game/fondo.png",
    "type": "image"
  },
  {
    "name": "m2",
    "src": "assets/game/m2.png",
    "type": "image"
  },
  {
    "name": "baldosa",
    "src": "assets/game/baldosa.png",
    "type": "image"
  },
  {
    "name": "box",
    "src": "assets/game/box.png",
    "type": "image"
  },
  {
    "name": "clemen",
    "src": "assets/game/clemen.png",
    "type": "image"
  },
  {
    "name": "geiser",
    "src": "assets/game/geiser.png",
    "type": "image"
  },
  {
    "name": "luna",
    "src": "assets/game/luna.png",
    "type": "image"
  },
  {
    "name": "marte-old",
    "src": "assets/game/marte-old.png",
    "type": "image"
  },
  {
    "name": "marte",
    "src": "assets/game/marte.png",
    "type": "image"
  },
  {
    "name": "mercurio",
    "src": "assets/game/mercurio.png",
    "type": "image"
  },
  {
    "name": "pared",
    "src": "assets/game/pared.png",
    "type": "image"
  },
  {
    "name": "robot",
    "src": "assets/game/robot.png",
    "type": "image"
  },
  {
    "name": "robot50",
    "src": "assets/game/robot50.png",
    "type": "image"
  },
  {
    "name": "spacebase",
    "src": "assets/game/spacebase.png",
    "type": "image"
  },
  {
    "name": "spaceroute",
    "src": "assets/game/spaceroute.png",
    "type": "image"
  },
  {
    "name": "spinning_coin_gold",
    "src": "assets/game/spinning_coin_gold.png",
    "type": "image"
  },
  {
    "name": "tina",
    "src": "assets/game/tina.png",
    "type": "image"
  },
  {
    "name": "tunnel",
    "src": "assets/game/tunnel.png",
    "type": "image"
  },
  {
    "name": "wooden_box",
    "src": "assets/game/wooden_box.png",
    "type": "image"
  },
  {
    "name": "area01",
    "src": "assets/game/area01.tmx",
    "type": "tmx"
  },
  {
    "name": "area02",
    "src": "assets/game/area02.tmx",
    "type": "tmx"
  },
  {
    "name": "area03",
    "src": "assets/game/area03.tmx",
    "type": "tmx"
  },
  {
    "name": "area05",
    "src": "assets/game/area05.tmx",
    "type": "tmx"
  },
  {
    "name": "area06",
    "src": "assets/game/area06.tmx",
    "type": "tmx"
  },
  {
    "name": "area04",
    "src": "assets/game/area04.tmx",
    "type": "tmx"
  },
  {
    "name": "area07",
    "src": "assets/game/area07.tmx",
    "type": "tmx"
  },
  {
    "name": "area08",
    "src": "assets/game/area08.tmx",
    "type": "tmx"
  },
  {
    "name": "area09",
    "src": "assets/game/area09.tmx",
    "type": "tmx"
  },
  {
    "name": "area10",
    "src": "assets/game/area10.tmx",
    "type": "tmx"
  },
  {
    "name": "area11",
    "src": "assets/game/area11.tmx",
    "type": "tmx"
  },
  {
    "name": "area12",
    "src": "assets/game/area12.tmx",
    "type": "tmx"
  },
  {
    "name": "area13",
    "src": "assets/game/area13.tmx",
    "type": "tmx"
  }
]